<!-- Form Past Due Alerts -->
<div *ngFor="let alert of formAlerts"
  class="d-flex alert-box mb-4">
  <div class="alert-warning">
    <div class="mt-2">
      <yc-fa
        class="alert-icon" 
        icon="exclamation-circle">
      </yc-fa>
    </div>
  </div>

  <!-- Non Mobile -->
  <div class="d-none d-md-flex justify-content-between align-items-center flex-grow-1 p-2 bg-white">
    <div>
      <!-- Header -->
      <ng-template *ngTemplateOutlet="alertHeader"></ng-template>
      <div class="d-flex mt-2">
        <!-- Program -->
        <ng-template *ngTemplateOutlet="program; context: { alert: alert }">
        </ng-template>
        <!-- App ID -->
        <ng-template *ngTemplateOutlet="appId; context: {
          alert: alert,
          isMobile: false
        }">
        </ng-template>
        <!-- Form -->
        <ng-template *ngTemplateOutlet="form; context: { alert: alert}">
        </ng-template>
        <!-- Due Date -->
        <div>
          <ng-template *ngTemplateOutlet="dueDate; context: { alert: alert}">
          </ng-template>
        </div>
      </div>
    </div>
    <!-- Revise Form -->
    <ng-template *ngTemplateOutlet="viewForm; context: {
      alert: alert,
      isMobile: false
    }">
    </ng-template>
  </div>

  <!-- Mobile -->
  <div class="p-2 d-md-none bg-white">
    <div>
      <!-- Header -->
      <ng-template *ngTemplateOutlet="alertHeader"></ng-template>
      <div class="mt-2 mb-4">
        <!-- App ID -->
        <ng-template *ngTemplateOutlet="appId; context: {
          alert: alert,
          isMobile: true
        }">
        </ng-template>
        <!-- Program -->
        <ng-template *ngTemplateOutlet="program; context: { alert: alert }">
        </ng-template>
        <!-- Form -->
        <ng-template *ngTemplateOutlet="form; context: { alert: alert}">
        </ng-template>
        <!-- Due Date -->
        <div>
          <ng-template *ngTemplateOutlet="dueDate; context: { alert: alert}">
          </ng-template>
        </div>
      </div>
    </div>
    <!-- Revise Form -->
    <ng-template *ngTemplateOutlet="viewForm; context: {
      alert: alert,
      isMobile: true
    }">
    </ng-template>
  </div>
</div>

<!-- Start Templates -->

<!-- Program Template-->
<ng-template #program let-alert="alert">
  <div *ngIf="!hideProgram" class="me-4">
    <yc-i18n class="add-weight"
      key="common:lblProgram"
      defaultValue="Program">
    </yc-i18n>:
    <h2 class="program-name">
      {{ programTranslationMap[alert.grantProgramId]?.Name ||   
        alert.grantProgramName }}
    </h2>
  </div>
</ng-template>

<!-- ID Template-->
<ng-template #appId
  let-alert="alert"
  let-isMobile="isMobile">
  <div *ngIf="!hideAppId"
    [id]="(isMobile ? 'mobile-alert-' : 'standard-alert-') + alert.applicationId"
    class="me-4">
    <yc-i18n class="add-weight"
      key="common:textId"
      defaultValue="ID">
    </yc-i18n>:
    <span>
      {{ alert.applicationId }}
    </span>
  </div>
</ng-template>

<!-- Form Template-->
<ng-template #form let-alert="alert">
  <div *ngIf="!hideForm" class="me-4">
    <yc-i18n class="add-weight"
      key="GLOBAL:textForm"
      defaultValue="Form">
    </yc-i18n>:
    <span>
      {{ formTranslationMap[alert.formId]?.Name ||   
        alert.name }}
    </span>
  </div>
</ng-template>

<!-- Header Template-->
<ng-template #alertHeader>
  <div class="header">
    {{ alertHeaderText }}
  </div>
</ng-template>


<!-- Due Date -->
<ng-template #dueDate let-alert="alert">
  <yc-i18n class="add-weight"
    key="common:textDueDate"
    defaultValue="Due date">
  </yc-i18n>: {{ alert.dueDate | ycFormDueDate }}
</ng-template>

<!-- View Form Button-->
<ng-template #viewForm
  let-alert="alert"
  let-isMobile="isMobile">
  <div *ngIf="!hideFormAction">
    <yc-button
      [primary]="true"
      [ariaDescribedBy]="(isMobile ? 'mobile-alert-' : 'standard-alert-') + alert.applicationId"
      [langKey]="'APPLY:textViewForm'"
      [defaultText]="'View form'"
      (onClick)="goToForm(alert)">
    </yc-button>
  </div>
</ng-template>

<!-- End Templates -->


